import {Subject} from "rxjs";

export class DealEvents {

    /**
     * Notifies a change in the status of deals.
     */
    public static readonly dealStatusChanged$: Subject<void> = new Subject();
}



// WEBPACK FOOTER //
// ./src/app/deal/deal-events.ts